import styled from "styled-components";

export const StyledBasicCheckboxV2 = styled.div`
  display: flex;
  align-items: center;
`;